import { Controller } from "@hotwired/stimulus";
import ApexCharts from "apexcharts";

export default class extends Controller {
  static values = {
    series: Array,
    labels: Array
  }
  connect() {

    var options = {
      series: this.seriesValue,
      labels: this.labelsValue,
      chart: {
        height: 235,
        type: 'donut',
      },
      dataLabels: {
        enabled: false,
      },

      legend: {
        show: false,
      },
      stroke: {
        width: 0,
      },
      plotOptions: {
        pie: {
          startAngle: -90,
          endAngle: 90,
          offsetY: 10,
          expandOnClick: false,
          donut: {
            size: '80%',
            background: 'transparent',
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: '20px',
                color: '#495057',
                fontFamily: "Montserrat, sans-serif",
                offsetY: -35
              },
              value: {
                show: true,
                fontSize: '22px',
                color: undefined,
                offsetY: -25,
                fontWeight: 600,
                fontFamily: "Montserrat, sans-serif",
                formatter: function (val) {
                  return val + "%"
                }
              },
              total: {
                show: true,
                showAlways: true,
                label: 'Total Queries',
                fontSize: '14px',
                fontWeight: 400,
                color: '#495057',
              }
            }
          }
        }
      },
      grid: {
        padding: {
          bottom: -85
        }
      },
      colors: ["rgba(var(--primary-rgb))", "rgba(255, 90, 41, 1)", "rgba(12, 199, 99, 1)", "rgba(12, 156, 252, 1)"],
    };
    var chart = new ApexCharts(this.element, options);
    chart.render();
  }
}
